import { create } from "zustand";

export interface BetaNotifStoreProps {
  /**
   * Tinggi banner beta yang sedang tampil, 0 jika banner tertutup.
   * Dipakai layout lain (sidebar, dsb) untuk menyisakan ruang
   * supaya kontennya tidak tertutup banner yang position fixed.
   */
  height: number
  setHeight: (height: number) => void
}

const betaNotifStore = create<BetaNotifStoreProps>((set) => ({
  height: 0,
  setHeight: (height) => set((state) => ({
    ...state,
    height,
  })),
}))

export default betaNotifStore
